import qs from 'qs';

export function getRequestHash(path: string, method: string, params?: object) {
  return JSON.stringify({
    path,
    method,
    params,
  });
}

export function getRequestUrl<TParams = never>(path: string, params?: TParams) {
  if (params) {
    const query = qs.stringify(params, {
      skipNulls: true,
    });
    return query ? `${path}?${query}` : path;
  }

  return path;
}

export function isPromiseFulfilled<T>(
  result: PromiseSettledResult<T>
): result is PromiseFulfilledResult<T> {
  return result.status === 'fulfilled';
}
